import { Button, TableCell } from "@mui/material";
import { FaCheck, FaTimes } from "react-icons/fa";
const ActionsCell = ({ update, handleActionClick, handleShowDetails }) => (
  <TableCell align="center">
    <div className="flex gap-2 justify-center items-center">
      <Button
        variant="outlined"
        color="info"
        size="small"
        onClick={() => handleShowDetails(update)}
      >
        View Details
      </Button>
      {update.status === "pending" && (
        <>
          <Button
            variant="contained"
            color="success"
            startIcon={<FaCheck />}
            onClick={() => handleActionClick(update.id, "approve")}
            size="small"
          >
            Approve
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<FaTimes />}
            onClick={() => handleActionClick(update.id, "reject")}
            size="small"
          >
            Reject
          </Button>
        </>
      )}
    </div>
  </TableCell>
);
export default ActionsCell;
